import { Chip, Grid, Typography } from "@mui/material";

import Link from "../components/Link";

interface FilterChipsProps {
  title: string;
  filter: "me" | "cluster";
  dateRange: "today" | "thisWeek" | null;
  seeAllLink: string;
  onFilterChange: (filter: "me" | "cluster") => void;
  onDateRangeChange: (dateRange: "today" | "thisWeek" | null) => void;
  filterTextOverrides?: {
    me?: string;
  };
}

export const FilterChips = ({
  title,
  filter,
  dateRange,
  onFilterChange,
  onDateRangeChange,
  seeAllLink,
  filterTextOverrides,
}: FilterChipsProps) => {
  return (
    <Grid container alignItems="center" sx={{ marginBottom: 0.5 }}>
      <Typography variant="h4">{title}</Typography>
      <Chip
        size="small"
        label={filterTextOverrides?.me || "Submitted by me"}
        color={filter === "me" ? "primary" : "default"}
        onClick={() => {
          const newFilter = filter === "me" ? "cluster" : "me";
          onFilterChange(newFilter);
        }}
        sx={{ marginRight: 1, marginLeft: 2, fontSize: 12 }}
      />
      <Chip
        size="small"
        label="Today"
        color={dateRange === "today" ? "primary" : "default"}
        onClick={() => {
          onDateRangeChange(dateRange === "today" ? null : "today");
        }}
        sx={{ marginRight: 1, fontSize: 12 }}
      />
      <Chip
        size="small"
        label="This Week"
        color={dateRange === "thisWeek" ? "primary" : "default"}
        onClick={() => {
          onDateRangeChange(dateRange === "thisWeek" ? null : "thisWeek");
        }}
        sx={{ marginRight: 1, fontSize: 12 }}
      />
      <Link to={seeAllLink}>See all</Link>
    </Grid>
  );
};
